import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { Tooltip } from 'react-tooltip';

import {
  TicketModalDescription,
  TicketContainer,
  TicketModalSpan,
  TicketLinkRow,
  TicketLink,
  CopyLinkButton,
  CopyIcon,
  LanguagesAllowedContainer,
} from './styles';
import { ModalContent } from '../styles';
import { Modal, Header, Body, Footer, FooterButton } from '../modalElements';
import { getConfig } from 'functions/getConfig';
import { Languages } from 'constants/languages';

export default React.memo(({ tickets, closeModal }) => {
  const configuration = getConfig();

  const [isOpen, setIsOpen] = useState(true);

  const hideModal = () => {
    setIsOpen(false);
    return closeModal && closeModal();
  };

  const copyTicketLink = (ticketLink) => {
    navigator.clipboard.writeText(ticketLink);
    toast.success('Successfully copied link to clipboard!');
  };

  const getLanguagesAllowed = (ticket) => ticket?.languagesAllowed?.map((t) => `${Languages[t].SimpleName}`).join(', ');

  return (
    <Modal isOpen={isOpen}>
      <Header>Test link generated</Header>
      <Body>
        <ModalContent>
          <TicketModalDescription>
            {tickets.length === 1
              ? 'Your tests are created. The link below leads directly to the ticket.'
              : 'Your tests are created. The links below lead directly to the tickets.'}
          </TicketModalDescription>
          {tickets.map((userTickets, index) => {
            const ticket = userTickets[0] ?? userTickets;
            const ticketLink = `${configuration.REACT_URL}/session/${ticket.session}`;
            return (
              <TicketContainer key={index}>
                <Tooltip id={`languagesAllowed${ticket._id}`} place="top" className="custom-tooltip" />
                {ticket?.languagesAllowed?.length && (
                  <LanguagesAllowedContainer>
                    Allowed languages ({ticket.languagesAllowed.length}){' '}
                    <i
                      className="fa fa-info-circle"
                      aria-hidden="true"
                      data-tooltip-id={`languagesAllowed${ticket._id}`}
                      data-tooltip-content={getLanguagesAllowed(ticket)}
                      data-tooltip-variant="info"
                    />
                  </LanguagesAllowedContainer>
                )}
                <TicketModalSpan>Link to ticket for {ticket.userData.name}</TicketModalSpan>
                <TicketLinkRow>
                  <TicketLink defaultValue={ticketLink} disabled></TicketLink>
                  <CopyLinkButton onClick={() => copyTicketLink(ticketLink)}>
                    <CopyIcon />
                  </CopyLinkButton>
                </TicketLinkRow>
                {ticket.autoEmail && ticket.userData.email !== '' && (
                  <TicketModalSpan>Test was sent to: {ticket.userData.email}</TicketModalSpan>
                )}
              </TicketContainer>
            );
          })}
        </ModalContent>
      </Body>
      <Footer>
        <FooterButton label="Close" onClick={hideModal} autoFocus={true} />
      </Footer>
    </Modal>
  );
});
